import axios from 'axios'; 
import { data } from 'jquery';

const state = { 
	miSeleccion: []
};

const getters = {
	getMiSeleccion: (state, getters) => (tipo) => { 
		return (tipo == 'total') ? state.miSeleccion : state.miSeleccion[tipo]; 
	}
}

const mutations = {
	setMiSeleccion: (state, datos) => {	state.miSeleccion = datos; },
	//toggleChecked: (state, id) => {	state.miSeleccion = datos; }
	setItemSeleccionado: (state, datos) => {
		var obj = state.miSeleccion[datos.datos.tipo].find(function (obj) { return obj.id_articulo === datos.datos.id_articulo; })
		obj.seleccionado = datos.value
	},
	setItemCantidad: (state, datos) =>{
		var obj = state.miSeleccion[datos.datos.tipo].find(function (obj) { return obj.id_articulo === datos.datos.id_articulo; });
		obj.cantidad = datos.cantidad;
    obj.importe = parseFloat((obj.precio * obj.cantidad).toFixed(2));
	},
	deleteItem: (state, datos) =>{
		var index = state.miSeleccion[datos.datos.tipo].map(function(obj) { return obj.id_articulo; }).indexOf(datos.datos.id_articulo);
		state.miSeleccion[datos.datos.tipo].splice(datos.index, 1);
	},
	setItemsSelectedAll: (state, datos) => {
		state.miSeleccion[datos.tipo].forEach( item => ( !item.descatalogado && !item.proximamente ) ? item.seleccionado = datos.value : item.seleccionado = 0 )
	}
};

const actions = {
	updateChecked: ( { commit, state, rootState, rootGetters }, datos ) => {	
		var obj = state.miSeleccion[datos.tipo].find(function (obj) { return obj.id_articulo === datos.id_articulo; });
		var oldValue = obj.seleccionado;
		var newValue = (oldValue == 0) ? 1 : 0;

		if( obj.descatalogado ){
			alert(obj.descatalogado);
		}else if( obj.proximamente ){
			alert("El árticulo estará disponible el " + obj.proximamente);
		}else{
			// convert to mutation
			//obj.seleccionado = null;
			commit('setItemSeleccionado', { datos: datos, value: null })

			axios.put( rootState.apiURL + rootGetters.getLocale + '/miseleccion',
				{
					id: obj.id_articulo,
					cantidad: obj.cantidad,
					seleccionado: newValue
				})
	    .then( (respuesta) =>{
				// convert to mutation
				//obj.seleccionado = newValue;
				//console.log(newValue)
				//console.log(datos)
				commit('setItemSeleccionado', { datos: datos, value: newValue })
	    })
	    .catch( (error) =>{ 
	    	alert(error.response.data.status + ' ' + error.response.data.msg);
			});
		}
	},
	updateCantidad: ( { commit, state, rootState, rootGetters }, datos ) => {	
		var obj = state.miSeleccion[datos.tipo].find(function (obj) { return obj.id_articulo === datos.id_articulo; });
		var newValue = (datos.cantidad > 9999) ? 9999 : (datos.cantidad < 1) ? 1 : datos.cantidad ;
		
		// convert to mutation
		//obj.importe = null;
		commit('setItemCantidad', { datos: datos, cantidad: null })

		axios.put( rootState.apiURL + rootGetters.getLocale + '/miseleccion',
			{
				id: obj.id_articulo,
				cantidad: newValue,
				seleccionado: obj.seleccionado
			})
    .then( (respuesta) =>{
			// convert to mutation
    	/* obj.cantidad = newValue;
			 obj.importe = parseFloat((obj.precio * obj.cantidad).toFixed(2)); */
			commit('setItemCantidad', { datos: datos, cantidad: newValue })
     	//alert(typeof obj.importe);
    })
    .catch( (error) =>{ 
    	alert(error.response.data.status + ' ' + error.response.data.msg);
		});
	},
	deleteArticulo: ( { commit, state, rootState, rootGetters }, datos ) => {	
		var index = state.miSeleccion[datos.tipo].map(function(obj) { return obj.id_articulo; }).indexOf(datos.id_articulo);
		axios.delete( rootState.apiURL + rootGetters.getLocale + '/miseleccion/' + datos.id_articulo)
    .then( (respuesta) =>{
			//convert to mutation
			//state.miSeleccion[datos.tipo].splice(index, 1);
			commit('deleteItem', { datos: datos, index: index })
    })
    .catch( (error) =>{ 
    	alert(error.response.data.status + ' ' + error.response.data.msg);
		});
	},
	checkAllArticulosTipo: ( { commit, state, rootState, rootGetters }, datos ) => {	
		let length = state.miSeleccion[datos.tipo].length;
		let aux = state.miSeleccion[datos.tipo];

		// convert to mutation
		/* for (var j=0; j<length; j++ ){
			if( !aux[j].descatalogado && !aux[j].proximamente ){
				aux[j].seleccionado = null;
			}
		} */
		commit('setItemsSelectedAll', { tipo: datos.tipo, value: null })

    axios.put( rootState.apiURL + rootGetters.getLocale + '/miseleccion/' + datos.tipo,
			{
				seleccionado: 1
			})
    .then( (respuesta) =>{
    	/* for (var j=0; j<length; j++ ){
	      if( !aux[j].descatalogado && !aux[j].proximamente ){
					aux[j].seleccionado = 1;
				}
			} */
			commit('setItemsSelectedAll', { tipo: datos.tipo, value: 1 })
    })
    .catch( (error) =>{ 
    	alert(error.response.data.status + ' ' + error.response.data.msg);
		});
	},
	uncheckAllArticulosTipo: ( { commit, state, rootState, rootGetters }, datos ) => {	
		let length = state.miSeleccion[datos.tipo].length;
		let aux = state.miSeleccion[datos.tipo];

		/* for (var j=0; j<length; j++ ){
      aux[j].seleccionado = null;
		} */
		commit('setItemsSelectedAll', { tipo: datos.tipo, value: null })

		axios.put( rootState.apiURL + rootGetters.getLocale + '/miseleccion/' + datos.tipo,
			{
				seleccionado: 0
			})
    .then( (respuesta) =>{
    	/* for (var j=0; j<length; j++ ){
	      aux[j].seleccionado = 0;
			} */
			commit('setItemsSelectedAll', { tipo: datos.tipo, value: 0 })
    })
    .catch( (error) =>{ 
    	alert(error.response.data.status + ' ' + error.response.data.msg);
		});
	},
	deleteAllArticulosTipo: ( { commit, state, rootState, rootGetters }, datos ) => {		
		let length = state.miSeleccion[datos.tipo].length;
		let aux = state.miSeleccion[datos.tipo];
		axios.delete( rootState.apiURL + rootGetters.getLocale + '/miseleccion/' + datos.tipo)
    .then( (respuesta) =>{
    	state.miSeleccion[datos.tipo] = [];
    })
    .catch( (error) =>{ 
    	alert(error.response.data.status + ' ' + error.response.data.msg);
		});
	},
};


export default {
	state,
	getters,
	mutations,
	actions
};
